module.exports = __webpack_public_path__ + "static/media/equipe-jackson-avatar@2x.ff880f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/equipe/equipe-jackson-avatar@2x.png
// module id = 192
// module chunks = 0